import React from 'react';
import _ from 'lodash';
import axios from 'axios';
import { components } from 'react-select';
import styled from 'styled-components';
import CrmAvatar from './CrmAvatar';

// SizedAvatar overrides the global `.team-avatar { width/height: 40px !important; }`
// rule (TeamManager/styles/teamManagerStyles.css) so CrmAvatar can render at the
// requested size in compact dropdown contexts. Remove this wrapper once that
// global !important rule is gone from CrmAvatar's base class.
export const SizedAvatar = styled.span`
  display: inline-flex;
  .team-avatar {
    width: ${props => props.$size}px !important;
    height: ${props => props.$size}px !important;
    min-width: ${props => props.$size}px !important;
    max-width: ${props => props.$size}px !important;
    font-size: ${props => Math.round(props.$size * 0.45)}px !important;
  }
`;

// Shared debounced fetch for the artist typeahead. Returns option objects with
// every field any current caller needs — consumers ignore what they don't use:
//   { value, label, permalink, imageUrl, object: { artistable } }
export const fetchArtistOptions = _.debounce((inputValue, callback) => {
  if (!inputValue) {
    callback([]);
    return;
  }
  axios.get('/artists/search_by_name', { params: { name: inputValue } })
    .then(({ data }) => {
      callback(data.map((a) => ({
        value: a.id,
        label: a.name,
        permalink: a.permalink,
        imageUrl: a.image_thumb_url,
        inRoster: a.in_roster,
        object: { artistable: a },
      })));
    })
    .catch(() => callback([]));
}, 250);

export const ArtistOption = (props) => (
  <components.Option {...props}>
    <div className="d-flex align-items-center">
      <SizedAvatar $size={28}>
        <CrmAvatar name={props.data.label} avatarUrl={props.data.imageUrl} size={28} />
      </SizedAvatar>
      <span className="ml-2">{props.data.label}</span>
    </div>
  </components.Option>
);

export const ArtistSingleValue = (props) => (
  <components.SingleValue {...props}>
    <div className="d-flex align-items-center">
      <SizedAvatar $size={20}>
        <CrmAvatar name={props.data.label} avatarUrl={props.data.imageUrl} size={20} />
      </SizedAvatar>
      <span className="ml-2">{props.data.label}</span>
    </div>
  </components.SingleValue>
);

export const artistSingleSelectComponents = {
  Option: ArtistOption,
  SingleValue: ArtistSingleValue,
};
